import Logger from "js-logger";
import keycloakStore from "@/businesslogic/stores/keycloakStore";
import axios from "axios";
import dateUtils from "@/businesslogic/utils/dateUtils";
import {Anfrage} from "@/model/Anfrage";

const {dateStringToIsoDate, getAlterZuStichtag} = dateUtils();

class ExtraSelbstbeteiligungService {
    http() {
        const keycloakAccessToken = keycloakStore().getKeycloakAccessToken();

        let headers;
        if (keycloakAccessToken) {
            headers = {
                Authorization: "Bearer " + keycloakAccessToken,
                "Content-Type": "application/json",
            };
        }
        return axios.create({
            baseURL: process.env.VUE_APP_BACKEND_URL,
            timeout: process.env.VUE_APP_BACKEND_TIMEOUT,
            headers: headers,
        });
    }

    getBaseUrl(isMakler: boolean) {
        if (!isMakler) {
            return "/api/direkt/";
        } else {
            return "/api/makler/";
        }
    }

    leitungswasserSelbstbeteiligungPruefen(anfrage: Anfrage, versicherungsbeginn: string) {
        return this.http()
            .post(this.getBaseUrl(anfrage.isMakler) + "sanierung/checkLeitungswasserSelbstbeteiligung", {
                sanierungsdaten: anfrage.gebaeudedaten.sanierungsdaten,
                versicherungsbeginn: versicherungsbeginn,
                baujahr: anfrage.gebaeudedaten.baujahr,
            })
            .then((antwort: any) => {
                Logger.debug("Antwort Leitungswasser SB muss vergeben werden:", antwort);
                return antwort;
            })
            .catch((fehler) => {
                Logger.debug("Prüfung auf Leitungswasser SB schlug fehl:", fehler);
            });
    }

    vgvSelbstbeteiligungVorversicherungFehltPruefen(
        isMakler: boolean,
        vorversicherungEndeDatum: any,
        vorversicherungVorhanden: boolean | null,
        versBeginn: any,
    ) {
        if (isMakler === false) {
            return;
        }
        console.log("VORVERSICHERUNG: " + vorversicherungVorhanden);
        return vorversicherungVorhanden === false || (vorversicherungEndeDatum && versBeginn &&
            this.keineVorversicherungLetzt12Monate(vorversicherungEndeDatum, dateStringToIsoDate(versBeginn)));
    }

    vhvSelbstveteiligungVorversicherungFehltPruefen(storeData: Anfrage) {
        const antragsart = storeData.vorversicherung.antragsart;
        const geburtsdatum = storeData.personendaten.versicherungsnehmer.geburtsdatum;
        const versicherungsbeginn = storeData.tarifinformationen.versicherungsbeginn;
        const vertragsende = storeData.vorversicherung.vertragEnde;
        const alter = this.berechneAlter(geburtsdatum, versicherungsbeginn);
        if (storeData.isMakler || storeData.vorversicherung.vertragEnde == undefined) {
            return;
        }
        Logger.debug("watch.modalZusatzSbKeineVorversicherung: Errechnetes Alter zum Beginn: " + alter);
        if (alter && alter > 30 &&
            process.env.VUE_APP_VHV_SB_KEINE_VORVERSICHERUNG_AKTIV == "true" &&
            antragsart.toLowerCase() == "neu") {
            return true;
        }
        if (alter && alter > 30 &&
            process.env.VUE_APP_VHV_SB_KEINE_VORVERSICHERUNG_AKTIV == "true" &&
            (antragsart.toLowerCase() === "wechsel")) {
            if(vertragsende === "") {
                return;
            }
            return this.keineVorversicherungLetzt12Monate(vertragsende, dateStringToIsoDate(versicherungsbeginn));
        }
   }

    berechneAlter(geburtsdatum: string, versicherungsbeginn: string) {
        if (geburtsdatum && versicherungsbeginn) {
            return getAlterZuStichtag(geburtsdatum, versicherungsbeginn);
        }
        return undefined;
    };

    keineVorversicherungLetzt12Monate(vorversicherungEndeDatum: string, versBeginn: string) {
        const vorversicherungGrenzDatum = dateStringToIsoDate(vorversicherungEndeDatum);
        vorversicherungGrenzDatum.setDate(vorversicherungGrenzDatum.getDate() + 365);
        return vorversicherungGrenzDatum < versBeginn;
    }
}

export default new ExtraSelbstbeteiligungService();
